import * as types from '../constants';

export function loadAmberReports(currentPage) {
  return {
    type: types.LOAD_AMBER_REPORTS,
    currentPage,
  };
}

export function loadAmberReport(uuid) {
  return {
    type: types.LOAD_AMBER_REPORT,
    uuid,
  };
}

export function loadAmberReportCount() {
  return {
    type: types.LOAD_AMBER_REPORT_COUNT,
  };
}

export function loadAmberReportFeeds() {
  return {
    type: types.LOAD_AMBER_REPORT_FEEDS,
  };
}

export function loadAmberReportTags() {
  return {
    type: types.LOAD_AMBER_REPORT_TAGS,
  };
}

export function filterAmberReports(filterParams) {
  return {
    type: types.FILTER_AMBER_REPORTS,
    filterParams,
  };
}

export function checkEnrichmentFeedHasBlogs(uuids) {
  return {
    type: types.CHECK_ENRICHMENT_FEED_HAS_BLOGS,
    uuids,
  };
}

export function resetEnrichmentFeedHasBlogsState() {
  return {
    type: types.RESET_CHECK_ENRICHMENT_FEED_HAS_BLOGS_STATE,
  };
}

export function setAmberReportsAsSeen() {
  return {
    type: types.SET_AMBER_REPORTS_AS_SEEN,
  };
}

export function setAmberReportUnseen(uuid) {
  return {
    type: types.SET_AMBER_REPORT_UNSEEN,
    uuid,
  };
}

export function setAmberReportSeen(uuid) {
  return {
    type: types.SET_AMBER_REPORT_SEEN,
    uuid,
  };
}
